import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainBulkExtensionQueryQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainBulkExtensionQueryQuery = { __typename?: 'Query', domains?: { __typename?: 'DomainList', items: Array<{ __typename?: 'Domain', name: string } | null> } | null, usersBulk: Array<{ __typename?: 'BulkUserInfo', shortNumber: string, displayName: string, e164?: string | null, homeNumber?: string | null, mobileNumber?: string | null, loginEmail?: string | null, multipleLogins: boolean, location: string, userPackageName?: string | null, provisionedDevice?: { __typename?: 'BulkUserDeviceInfo', vendor: string, macAddress: string } | null }>, domainAllocation: { __typename?: 'DomainAllocations', userPackages: Array<{ __typename?: 'DomainAllocationInfoWithName', name: string, domainAllocated: number }> }, vendors?: Array<{ __typename?: 'Vendor', name: string } | null> | null };

export type AvailableTranslationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AvailableTranslationsQuery = { __typename?: 'Query', availableTranslations?: Array<string | null> | null };

export type DomainBulkExtensionMutationMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  users: Array<Types.BulkUserModificationData>;
  profileNames: Array<Types.Scalars['String']['input']>;
  locations: Array<Types.LocationData>;
}>;


export type DomainBulkExtensionMutationMutation = { __typename?: 'Mutation', bulkUserModification: { __typename?: 'BulkUserModificationResult', users: { __typename?: 'BulkUserModificationResultUsers', created: number, updated: number }, locations: { __typename?: 'BulkUserModificationResultLocations', created: number, updated: number }, errors?: Array<{ __typename?: 'BulkUserModificationError', sheet: number, row: number, column?: number | null, type: string, context?: string | null }> | null } };


export const DomainBulkExtensionQueryDocument = gql`
    query DomainBulkExtensionQuery($domainId: Int!) {
  domains(id: $domainId) {
    items {
      name
    }
  }
  usersBulk(domainId: $domainId) {
    shortNumber
    displayName
    e164
    homeNumber
    mobileNumber
    loginEmail
    multipleLogins
    location
    userPackageName
    provisionedDevice {
      vendor
      macAddress
    }
  }
  domainAllocation(domainId: $domainId) {
    userPackages {
      name
      domainAllocated
    }
  }
  vendors {
    name
  }
}
    `;

/**
 * __useDomainBulkExtensionQueryQuery__
 *
 * To run a query within a React component, call `useDomainBulkExtensionQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainBulkExtensionQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainBulkExtensionQueryQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainBulkExtensionQueryQuery(baseOptions: Apollo.QueryHookOptions<DomainBulkExtensionQueryQuery, DomainBulkExtensionQueryQueryVariables> & ({ variables: DomainBulkExtensionQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainBulkExtensionQueryQuery, DomainBulkExtensionQueryQueryVariables>(DomainBulkExtensionQueryDocument, options);
      }
export function useDomainBulkExtensionQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainBulkExtensionQueryQuery, DomainBulkExtensionQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainBulkExtensionQueryQuery, DomainBulkExtensionQueryQueryVariables>(DomainBulkExtensionQueryDocument, options);
        }
export function useDomainBulkExtensionQuerySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainBulkExtensionQueryQuery, DomainBulkExtensionQueryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainBulkExtensionQueryQuery, DomainBulkExtensionQueryQueryVariables>(DomainBulkExtensionQueryDocument, options);
        }
export type DomainBulkExtensionQueryQueryHookResult = ReturnType<typeof useDomainBulkExtensionQueryQuery>;
export type DomainBulkExtensionQueryLazyQueryHookResult = ReturnType<typeof useDomainBulkExtensionQueryLazyQuery>;
export type DomainBulkExtensionQuerySuspenseQueryHookResult = ReturnType<typeof useDomainBulkExtensionQuerySuspenseQuery>;
export type DomainBulkExtensionQueryQueryResult = Apollo.QueryResult<DomainBulkExtensionQueryQuery, DomainBulkExtensionQueryQueryVariables>;
export const AvailableTranslationsDocument = gql`
    query AvailableTranslations {
  availableTranslations
}
    `;

/**
 * __useAvailableTranslationsQuery__
 *
 * To run a query within a React component, call `useAvailableTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableTranslationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableTranslationsQuery(baseOptions?: Apollo.QueryHookOptions<AvailableTranslationsQuery, AvailableTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableTranslationsQuery, AvailableTranslationsQueryVariables>(AvailableTranslationsDocument, options);
      }
export function useAvailableTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableTranslationsQuery, AvailableTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableTranslationsQuery, AvailableTranslationsQueryVariables>(AvailableTranslationsDocument, options);
        }
export function useAvailableTranslationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AvailableTranslationsQuery, AvailableTranslationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AvailableTranslationsQuery, AvailableTranslationsQueryVariables>(AvailableTranslationsDocument, options);
        }
export type AvailableTranslationsQueryHookResult = ReturnType<typeof useAvailableTranslationsQuery>;
export type AvailableTranslationsLazyQueryHookResult = ReturnType<typeof useAvailableTranslationsLazyQuery>;
export type AvailableTranslationsSuspenseQueryHookResult = ReturnType<typeof useAvailableTranslationsSuspenseQuery>;
export type AvailableTranslationsQueryResult = Apollo.QueryResult<AvailableTranslationsQuery, AvailableTranslationsQueryVariables>;
export const DomainBulkExtensionMutationDocument = gql`
    mutation DomainBulkExtensionMutation($domainId: Int!, $users: [BulkUserModificationData!]!, $profileNames: [String!]!, $locations: [LocationData!]!) {
  bulkUserModification(
    domainId: $domainId
    users: $users
    profileNames: $profileNames
    locations: $locations
  ) {
    users {
      created
      updated
    }
    locations {
      created
      updated
    }
    errors {
      sheet
      row
      column
      type
      context
    }
  }
}
    `;
export type DomainBulkExtensionMutationMutationFn = Apollo.MutationFunction<DomainBulkExtensionMutationMutation, DomainBulkExtensionMutationMutationVariables>;

/**
 * __useDomainBulkExtensionMutationMutation__
 *
 * To run a mutation, you first call `useDomainBulkExtensionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainBulkExtensionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainBulkExtensionMutationMutation, { data, loading, error }] = useDomainBulkExtensionMutationMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      users: // value for 'users'
 *      profileNames: // value for 'profileNames'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useDomainBulkExtensionMutationMutation(baseOptions?: Apollo.MutationHookOptions<DomainBulkExtensionMutationMutation, DomainBulkExtensionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DomainBulkExtensionMutationMutation, DomainBulkExtensionMutationMutationVariables>(DomainBulkExtensionMutationDocument, options);
      }
export type DomainBulkExtensionMutationMutationHookResult = ReturnType<typeof useDomainBulkExtensionMutationMutation>;
export type DomainBulkExtensionMutationMutationResult = Apollo.MutationResult<DomainBulkExtensionMutationMutation>;
export type DomainBulkExtensionMutationMutationOptions = Apollo.BaseMutationOptions<DomainBulkExtensionMutationMutation, DomainBulkExtensionMutationMutationVariables>;